import ComponentLayout from '~/src/layouts/component-layout';
import { Box, Text } from '@primer/react';
import * as React from 'react';
export default {
  ComponentLayout,
  Box,
  Text,
  React
};